import { BoxProps, useTheme } from '@mui/material';

import { Icon } from '@/components/Icon/Icon';
import { IconName } from '@/components/Icon/Icon.interface';
import { DecorateCell } from '@/components/Icon/Icon.styled';

import {
  MODAL_INDICATOR_BACKGROUND_SIZES,
  MODAL_INDICATOR_VARIANTS,
  ModalIndicatorType,
} from './ModalIndicator.config';

import { ModalIndicatorContainer } from './ModalIndicator.styled';

export type { ModalIndicatorType };

export type ModalIndicatorProps = {
  readonly type: ModalIndicatorType;
  readonly icon: IconName;
  readonly size?: number;
  readonly iconSize?: number;
  readonly containerProps?: BoxProps;
};
/**
 * @description This component is used to display a modal indicator.
 * @param type - The type of modal indicator to display. Type is the combination of Type and Style of the modal indicator from figma.
 */
export function ModalIndicator({
  type,
  icon,
  size = MODAL_INDICATOR_BACKGROUND_SIZES.L,
  iconSize = 48,
  containerProps,
}: ModalIndicatorProps) {
  const theme = useTheme();
  const variant = MODAL_INDICATOR_VARIANTS[type];

  return (
    <ModalIndicatorContainer {...containerProps}>
      <DecorateCell color={variant.backgroundColor(theme)} size={size}>
        <Icon name={icon} color={variant.iconColor} size={iconSize} />
      </DecorateCell>
    </ModalIndicatorContainer>
  );
}
